/* Design data that components need in JavaScript.

   Colours, type and spacing are NOT here — they live in styles/tokens.css as
   custom properties, so they respond to the colour scheme and can be themed
   without a rebuild. This file holds only the vocabulary that markup reads.
*/

/** Lesson kinds, shown on cards and rails. */
export const kindLabel = { read: 'READ', video: 'WATCH', trial: 'TRIAL', check: 'CHECK', assignment: 'BUILD' };

/** Lesson status, shown on cards. */
/* `open` is blank on purpose: with locking off (v1) most lessons are open, and
   a badge on every card is noise. The status still exists for aria. */
export const statusLabel = { done: 'CLEARED', active: 'RESUME', next: 'NEXT', locked: 'LOCKED', open: '' };

/* Without progress tracking there is nothing to resume, nothing to mark done,
   and no "next after the one you are on". Every label is blank: the first
   lesson is simply the first one in the list, and a reader does not need to be
   told where a numbered sequence begins. */
export const statusLabelNoProgress = { done: '', active: '', next: '', locked: '', open: '' };

/** Directive-block vocabulary, shared with the content's Markdown directives. */
export const blockKinds = ['notice', 'check', 'try', 'watch', 'track', 'lookup', 'submit'];
